// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MainNavigationDropdown_dropdown__sBROn","dropdownItem":"MainNavigationDropdown_dropdownItem__aR0SL"};